import { Controller } from "stimulus"

export default class extends Controller {
    static values = { url: String }
    previousQuestion() {
        let previousQuestionUrl = this.urlValue
        Turbo.visit(previousQuestionUrl)
    }
}